export function Grid({ children, ...rest }: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-8 px-4 sm:px-8 md:flex md:flex-wrap md:px-12 xl:px-16" {...rest}>
      {children}
    </div>
  )
}
